module.exports = __webpack_public_path__ + "static/media/HomePage-item3.bca8d3d7.webp";